const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8787';

function getToken() {
  return localStorage.getItem('pbt_token');
}

function setToken(token) {
  localStorage.setItem('pbt_token', token);
}

function clearToken() {
  localStorage.removeItem('pbt_token');
}

async function request(method, path, body, isFormData = false) {
  const token = getToken();
  const headers = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;
  if (!isFormData) headers['Content-Type'] = 'application/json';

  const res = await fetch(`${BASE_URL}${path}`, {
    method,
    headers,
    body: isFormData ? body : body ? JSON.stringify(body) : undefined
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: `HTTP ${res.status}` }));
    throw new Error(err.error || `HTTP ${res.status}`);
  }
  return res.json();
}

export const api = {
  BASE_URL,
  getToken,
  setToken,
  clearToken,

  auth: {
    login: (username, password) => request('POST', '/api/auth/login', { username, password }),
    me: () => request('GET', '/api/auth/me')
  },

  users: {
    list: () => request('GET', '/api/users'),
    create: (data) => request('POST', '/api/users', data),
    createAuthorized: (clientId, data) => request('POST', `/api/users/${clientId}/authorized`, data),
    resetPassword: (id, password) => request('PUT', `/api/users/${id}/password`, { password }),
    delete: (id) => request('DELETE', `/api/users/${id}`)
  },

  media: {
    list: () => request('GET', '/api/media'),
    upload: (file) => {
      const form = new FormData();
      form.append('file', file);
      return request('POST', '/api/media', form, true);
    },
  },

  projects: {
    list: () => request('GET', '/api/projects'),
    listAll: () => request('GET', '/api/projects/all'),
    create: (data) => request('POST', '/api/projects', data),
    update: (id, data) => request('PUT', `/api/projects/${id}`, data),
    delete: (id) => request('DELETE', `/api/projects/${id}`),
    reorder: (order) => request('PUT', '/api/projects/reorder', { order }),
    uploadImage: (projectId, file) => {
      const form = new FormData();
      form.append('image', file);
      return request('POST', `/api/projects/${projectId}/images`, form, true);
    },
    deleteImage: (projectId, imgId) => request('DELETE', `/api/projects/${projectId}/images/${imgId}`),
    reorderImages: (projectId, order) => request('PUT', `/api/projects/${projectId}/images/reorder`, { order }),
    addFromLibrary: (projectId, r2Key, originalFilename) => request('POST', `/api/projects/${projectId}/images/from-library`, { r2_key: r2Key, original_filename: originalFilename }),
    updateImage: (projectId, imgId, data) => request('PATCH', `/api/projects/${projectId}/images/${imgId}`, data),
  },

  briefs: {
    list: () => request('GET', '/api/briefs'),
    get: (id) => request('GET', `/api/briefs/${id}`),
    create: (data) => request('POST', '/api/briefs', data),
    update: (id, data) => request('PUT', `/api/briefs/${id}`, data),
    delete: (id) => request('DELETE', `/api/briefs/${id}`),

    addCard: (briefId, type, content) => request('POST', `/api/briefs/${briefId}/cards`, { type, content }),
    updateCard: (briefId, cardId, content) => request('PUT', `/api/briefs/${briefId}/cards/${cardId}`, { content }),
    deleteCard: (briefId, cardId) => request('DELETE', `/api/briefs/${briefId}/cards/${cardId}`),
    reorderCards: (briefId, order) => request('PUT', `/api/briefs/${briefId}/cards/reorder`, { order }),
    uploadImage: (briefId, cardId, file, caption = '') => {
      const form = new FormData();
      form.append('image', file);
      if (caption) form.append('caption', caption);
      return request('POST', `/api/briefs/${briefId}/cards/${cardId}/image`, form, true);
    }
  }
};
